<div [formGroup]="filterForm">
	<div class="grid pt-0">
		<div [class]="actionLayout('left')">
			<p-button id="buttonAddPermission" label="{{ 'ADD_PERMISSION' | translate }}" icon="pi cm-plus" size="large"
				(click)="addPermission()" [disabled]="isFinalUsers()" [rounded]="false" [text]="true" severity="primary"
				styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
			</p-button>
		</div>
		<div [ngClass]="actionLayout('center')" [class]="this.screenWidth <= MIN_WD_COL4_MTMA && this.screenWidth >= MAX_MD_WIDTH ? 'flex justify-content-start' : 'flex justify-content-center'">
			<p-button id="buttonCustomizeEmail" label="{{ 'CUSTOMIZE_EMAIL' | translate }}" icon="pi cm-mail"
				(click)="customizeEmail()" [disabled]="isFinalUsers()" [rounded]="false" [text]="true" severity="secondary"
				class="mt-2" styleClass="font-bold border-0">
			</p-button>
		</div>
		<div [class]="actionLayout('right')">
			<p-button id="buttonDeletePermission" label="{{ 'DELETE_ALL_EXPIRES' | translate }}" icon="pi cm-trash"
				size="large" (click)="deleteExpired()" [disabled]="isFinalUsers() || this.expiredPermissionsCount < 1" [rounded]="false" [text]="true"
				severity="danger" styleClass="font-bold border-50">
			</p-button>
		</div>
	</div>
	<div class="grid mt-0">
		<div [class]="col6HeaderPage('left')">
			<div
				[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'grid' : 'flex align-items-center justify-content-around w-full'">
				<div
					[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'col-6 flex align-items-center justify-content-center' : 'flex align-items-center'">
					<p-checkbox formControlName="activeFilter" name="activeFilter" [binary]="true"
						styleClass="mx-2"></p-checkbox>
					<p-tag value="{{ 'ACTIVE' | translate }}" severity="success"></p-tag>
				</div>
				<div
					[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'col-6 flex align-items-center justify-content-center' : 'flex align-items-center'">
					<p-checkbox formControlName="readyFilter" name="readyFilter" [binary]="true" styleClass="mx-2"></p-checkbox>
					<p-tag value="{{ 'READY' | translate }}" severity="warning"></p-tag>
				</div>
				<div
					[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'col-6 flex align-items-center justify-content-center' : 'flex align-items-center'">
					<p-checkbox formControlName="expiredFilter" name="expiredFilter" [binary]="true"
						styleClass="mx-2"></p-checkbox>
					<p-tag value="{{ 'EXPIRED' | translate }}" severity="danger"></p-tag>
				</div>
				<!-- <div [class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'col-6 flex align-items-center justify-content-center' : 'flex align-items-center'">
							<p-checkbox formControlName="createdFilter" name="createdFilter" [binary]="true" styleClass="mx-2"></p-checkbox>
							<p-tag value="{{ 'CREATED' | translate }}" styleClass="p-tag-info"></p-tag>
						</div> -->
			</div>
		</div>
		<div [class]="col6HeaderPage('right')">
			<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
				<i class="pi cm-search"></i>
				<input pInputText type="text" formControlName="searchFilter" name="searchFilter"
					id="permission-input-searchFilter" placeholder="{{ 'SEARCH' | translate }}"
					[ngClass]="dynamicInputTextWidth()" maxlength="254" class="surface-900" />
			</span>
		</div>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>